<template>
	<div>
		<div class = "quotations">
			<div class = "quotations_row">
                <transition 
                    enter-active-class="animated fadeInDown"
                    leave-active-class="animated fadeOut">
                    <div class="quotations-checker" v-show="showChecker" @mouseleave="hideChecker">
                    <div class="quotations-checker-item" 
                                v-for = "(item,index) in settings.selected" :key="index+'pair'">
                        <div class="quotations-checker-item-checkbox">
                            <input type="checkbox" @change = "cheсkPair(index)" :checked="settings.selected[index]"/>
                        </div>
                        <div class="quotations-checker-item-text">
                            {{index}}
                        </div>
                    </div>
                </div>
                </transition>
                <div class="quotations_item-icon" @click = "showOrHideChecker">
                    <i class="mdi mdi-format-list-bulleted"></i>
                </div>
				<div class = "quotations_item-title">Инструмент</div>
				<div class = "quotations_item-title">Продажа</div>
				<div class = "quotations_item-title">Спред</div>
				<div class = "quotations_item-title">Покупка</div>
			</div>
			<div class = "quotations_row" 
                v-for = "(quote, symbol) in selectedQuotes" 
				:key = "symbol">
				<div class = "quotations_item" style="justify-content:flex-start">
                    {{quote.name}}
                </div>
				<div class = "quotations_item" 
                    :class = "quote.sign < 0 ? 'trend-down' : 'trend-up'">
                    <i :class = "quote.sign < 0 ? 'icon-arrow-down' : 'icon-arrow-up'"></i>
                    {{quote.bid.toFixed(quote.prec)}}
                </div>
				<div class = "quotations_item">
                    {{parseFloat(((quote.ask - quote.bid) * Math.pow(10, quote.prec)).toFixed(quote.prec))}}
                </div>
				<div class = "quotations_item" 
                    :class = "quote.sign < 0 ? 'trend-down' : 'trend-up'">
                    <i :class = "quote.sign < 0 ? 'icon-arrow-down' : 'icon-arrow-up'"></i>
                    {{quote.ask.toFixed(quote.prec)}}
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Vue from "vue";
import { settingsStore } from "../../model/settings-store.js";

export default {
  data() {
    return {
      settings: {},
      showChecker:false
    };
  },
  methods: {
      cheсkPair(index) {
          this.settings.selected[index] = !this.settings.selected[index]
      },
      showOrHideChecker() {
          this.showChecker = !this.showChecker;
      },
      hideChecker() {
          this.showChecker = false;
      }
  },
  computed: {
    ...mapGetters({
      quotes: "quotes/getQuotes",
      filteredQuotes: "quotes/getFilteredQuotes"  
    }),
    getPair() {
        let pair = [{title:'EURUSD',
        show:true},
        {title:'GBPUSD',
        show:true},{title:'BTCUSD',
        show:true},{title:'ETHUSD',show:true},{title:'NZDUSD',show:true},{title:'AUDUSD',show:true}];
        return pair;
    },
    selectedQuotes() {
      if (!this.settings || !this.settings.selected) return {};
      return this.filteredQuotes(this.settings.selected);
    }
  },
  created() {
    let defaultSets = {
      selected: {
        EURUSD: true,
        GBPUSD: true,
        BTCUSD: true,
        ETHUSD: true,
        NZDUSD: true,
        AUDUSD: true,
        USDCAD: true
      }
    };
    
    Vue.set(this.$data, "settings", defaultSets);

  }
};
</script>

<style lang="less" scoped>
.quotations {
  background-color: #3d536b;
  border-radius: 4px;
  margin-bottom: 8px;

  &_row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #374b62;
    align-items: stretch;

    &:last-child {
      border-bottom: none;
    }
  }

  &_item {
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.15;
    letter-spacing: 0.4px;
    color: #ffffff;
    box-sizing: border-box;
    max-height: 28px;

    &-icon {
        display: flex;
        align-items: center;
        margin-left: 8px;

        i {
            font-size: 18px;
        }
    }

    i.icon-arrow-down {
      display: flex;
      font-size: 14px;
      width: 24px;
      justify-content: center;
      align-items: center;
      padding-bottom: 8px;
      padding-right: 4px;
      box-sizing: border-box;
    }

    i.icon-arrow-up {
      display: flex;
      font-size: 14px;
      width: 24px;
      justify-content: center;
      align-items: center;
      padding-top: 8px;
      padding-right: 4px;
      box-sizing: border-box;
    }

    &:first-child {
      padding-left: 36px;
      width: 100px;
      display: flex;
      justify-content: flex-end;
      box-sizing: border-box;
    }

    &:nth-child(2) {
      width: 96px;
      display: flex;
      justify-content: flex-end;
      text-align: right;
      margin-right: 24px;
    }

    &:nth-child(3) {
      width: 44px;
      display: flex;
      justify-content: flex-end;
      text-align: right;
    }

    &:nth-child(4) {
      width: 96px;
      padding-right: 12px;
      box-sizing: border-box;
      text-align: right;
      display: flex;
      justify-content: flex-end;
    }
  }

  &_item-title {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 4;
    letter-spacing: 0.4px;
    color: #aabed2;
    text-transform: uppercase;
    margin-right: 12px;

    &:first-child {
      padding-left: 12px;
      width: 100px;
      display: block;
      box-sizing: border-box;
    }

    &:nth-child(2) {
      width: 96px;
      display: block;
      text-align: left;
      padding-left: 12px;
    }

    &:nth-child(3) {
      width: 44px;
      display: block;
      text-align: right;
    }
    
    &:nth-child(4) {
      width: 96px;
      padding-right: 12px;
      box-sizing: border-box;
      text-align: right;
    }
  }

  &-checker {
    background-color: rgb(80, 107, 137);
    border-radius: 4px;
    position: absolute;
    z-index:1;
    box-shadow: 0 0 15px rgba(0,0,0,0.4);
    &-item {
        display: flex;
        border-bottom: 1px solid #465f7a;
        &:last-child {
            border-bottom: none;
        }
        input {
            margin: 8px;
        }
        &-text {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            display: flex;
            align-items: center;
            margin-right: 12px;
        }
    }
  }
}

.table-quotes td {
  padding: 2px 4px 2px 4px;
}
.table-quotes th {
  padding: 3px 4px 3px 4px;
}
.trend-down {
  color: #ff9292 !important;
}
.trend-up {
  color: #00ffd0 !important;
}
</style>